import { IconTickets } from '@components/Icons/Icons';
import { subNav } from '@components/Navbar/SubNav';

export const navId = 'subNavContentTickets';
const links = [
  { title: 'Open Tickets', href: '/tickets/existing' },
  { title: 'Create Ticket', href: '/tickets/create' },
  { title: 'Ticket History', href: '/tickets/history' },
];
const ticketsSubNav = () =>
  subNav({
    id: navId,
    title: 'Tickets',
    href: '/tickets',
    icon: IconTickets,
    links,
  });
export default ticketsSubNav;
